export default __webpack_public_path__ + "static/bg-99efef14f0178baf0d06ef70b335d95e.svg";